/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description React Hook useUpdateLocation
 */

import { useMutation, useQueryClient, UseMutationResult } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';
import { getLocationPath } from 'utils/router';
import { invalidateMetadata } from 'app-constants/queryKeys';
import { prepareLocationUpdateModel } from 'utils/admin/locations';

/**
 * Mutate for update  location
 *
 */
interface IProps {
	id: string;
	model: Location.IFormModel;
}

const useUpdateLocation = (disableRedirect?: boolean): UseMutationResult<unknown, IAxiosError, IProps, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ id, model }) => {
			await api.ServiceLocationDetailsApi.patchServiceLocationDetails({
				serviceLocationId: id,
				serviceLocationPatchModel: prepareLocationUpdateModel(id, model),
			});
		},
		onSuccess: (__, { id }) => {
			AppEvents.publishApiSuccess();
			invalidateMetadata(queryClient);
			if (!disableRedirect) {
				AppEvents.publishRedirect({ url: getLocationPath(id) });
			}
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useUpdateLocation;
